import { classNameType } from "@/types/generalTypes";
import React from "react";

function ArrowLeft({ className }: classNameType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 8 12"
      fill="none"
    >
      <path
        d="M3.1557 5.6704C2.96044 5.86566 2.96044 6.18224 3.1557 6.37751L7.19235 10.4142C7.38761 10.6094 7.38761 10.926 7.19235 11.1213L6.86924 11.4444C6.67398 11.6396 6.3574 11.6396 6.16214 11.4444L1.09529 6.37751C0.900024 6.18224 0.900024 5.86566 1.09529 5.6704L6.16214 0.603549C6.3574 0.408287 6.67398 0.408287 6.86924 0.60355L7.19235 0.926652C7.38761 1.12191 7.38761 1.4385 7.19235 1.63376L3.1557 5.6704Z"
        fill="#969696"
      />
    </svg>
  );
}

export default ArrowLeft;
